module.exports = __webpack_public_path__ + "static/img/ca04.9490139.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/items/ceges-ajandektargyak/ca04.jpg
// module id = 544
// module chunks = 0